<h2>Thanks for your order {{user.knownAs | titlecase}}!</h2>

Your order will be processed.
